import api from './api';
import { getEndPointPath, attachToken } from './helpers';

export const limit = 20;
export const offset = pageNumber => {
    return (pageNumber - 1) * limit;
};
export default class Transport {
    post(request) {
        const { path, data, query, config } = request;
        return api.post(getEndPointPath(path, query), data, config);
    }

    put(request) {
        const { path, data, query, config } = request;
        return api.put(getEndPointPath(path, query), data, config);
    }

    get(request) {
        const { path, query, config } = request;
        return api.get(getEndPointPath(path, query), config);
    }

    patch(request) {
        const { path, data, query, config } = request;
        return api.patch(getEndPointPath(path, query), data, config);
    }

    delete(request) {
        const { path, config } = request;
        return api.delete(getEndPointPath(path), config);
    }

    rememberToken(accessToken) {
        attachToken(api, accessToken);
    }
}

// export * from './types';
